<template>
  <table-view
    :total="total"
    v-loading="loading"
    :query-info.sync="queryInfo"
    @reload-table="renderTable"
  >
    <template #header>
      <view-search-form
        ref="searchFormRef"
        keyword-placeholder="姓名、学号、录取编号"
        :queryInfo.sync="queryInfo"
        :tool-list="['grade', 'stuStatus','college','major','keyword']"
        @on-search="renderTable(1)">
<!--        :insert-select-all="['stuStatus']"-->
        <el-form-item label="学制">
          <el-select v-model="queryInfo.lengthOfSchooling" clearable size="small">
            <el-option
              v-for="{paramName,paramValue} in $store.state.systemParam.lengthOfSchoolingType"
              :key="paramValue"
              :label="paramName"
              :value="Number(paramValue)" />
          </el-select>
        </el-form-item>
      </view-search-form>
      <div class="header-button">
        <PopoverSelectFields :check-list.sync="checkList"
                             :init-check-list="initCheckList"
                             :student-columns="studentColumns"
        />
        <ElDivider direction="vertical" />
        <el-button type="success" size="small" @click="()=>visibleDIYExportDialog=true">导出学生数据</el-button>
        <upload-excel download-title="下载老生导入模板"
                      import-title="批量导入老生"
                      :permit-key="['stu:edit']"
                      :loading.sync="loading"
                      :api="$http.importExcelHttp.importOldStudent"
                      @on-download="$http.exportExcelHttp.exportOldStudentTemplate()"
                      @on-success="renderTable(1)" />
      </div>
    </template>
    <!-- body -->
    <el-table :data="tableData" style="width: 100%" border stripe>
      <el-table-column type="index" label="ID" width="40" />
      <el-table-column v-for="(item) in compCols" :key="item.prop" :prop="item.prop" :label="item.label"
                       :align="item.align||'left'"
                       :min-width="item.minWidth" :width="item.minWidth?null:item.width">
        <template v-slot="{row}">
          <!-- showSubDialog的title属性没有上,借用来传递专业信息  -->
          <div class="flex" v-if="item.prop==='stuName'">
            {{ row.stuName }}
            <el-button type="text"
                       icon="el-icon-view"
                       @click="showSubDialog('visibleOnlyReadDialog','onlyReadDialogRef',row.id,row)">
            </el-button>
          </div>
          <template v-else-if="item.prop==='sexType'">
            {{ +row.sexType === 1 ? '男' : '女' }}
          </template>
          <template v-else-if="item.prop==='apartmentName'">
            <span v-if="row.dormitoryName && row.dormitoryBedNo"
            >{{ row.dormitoryName }}{{ row.roomName }}室{{
                row.dormitoryBedNo
              }}号床</span>
            <span class="font-grey" v-else-if="row.stuStatus===2">已毕业</span>
            <span v-else>未分配</span>
          </template>
          <template v-else-if="item.prop==='payPassFlag'">
            <!--   免缴费登录  -->
            <el-switch
              v-permission="['stu:import:edit']"
              v-model="row.payPassFlag"
              active-color="var(--color-success)"
              inactive-color="#d0d6e8"
              :active-value="1"
              active-text="是"
              :inactive-value="0"
              inactive-text="否"
              @change="handleSwitch(row)" />
          </template>
          <template v-else-if="item.prop==='stuStatus'">
            {{ $http.getParamName(row.stuStatus, $store.state.systemParam.stuStatus) }}
          </template>
          <template v-else-if="item.prop==='headshot'">
            <!--  门禁照片  -->
            <template v-if="row.headshot">
              <el-popover
                placement="top"
                width="189"
                :title="`门禁照片：${row.stuName}`"
                lazy
                trigger="hover">
                <el-image style="width:179px; height:auto;" :preview-src-list="[$fileUrl + row.headshot]"
                          :src="$fileUrl + row.headshot" fit="contain" />
                <el-button slot="reference" type="text" size="mini">
                  <i class="el-icon-more" />
                </el-button>
              </el-popover>
            </template>
            <span v-else class="font-grey">--无--</span>
          </template>
          <span v-else-if="item.prop==='className'">
          {{ row.className || '未绑定' }}
          </span>
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template v-slot="{ row }">
          <el-button
            v-permission="['stu:edit']"
            type="primary"
            size="mini"
            plain
            @click="showStatusDialog(row)"
          >设置学籍状态
          </el-button>
          <el-button
            v-permission="['stu:edit']"
            type="primary"
            size="mini"
            @click="showDialog(row.id,`${row.stuName}(${row.stuNo?row.stuNo:row.examineNo})`)"
          >编辑
          </el-button>
          <!--  不能删除学籍信息  -->
          <el-button
            v-permission="['stu:del']"
            v-if="false"
            size="mini"
            @click="del(deleteStudent,row.id,`${row.stuName}`)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--  设置学籍状态  -->
    <set-student-status ref="stuStatusDialogRef" :visible.sync="visibleStatusDialog" v-if="visibleStatusDialog"
                        @on-close="renderTable" />
    <student-dialog ref="dialogRef" :visible.sync="visibleDialog" v-if="visibleDialog" @on-close="renderTable" />
    <!--  查看学生信息 dialog  -->
    <student-only-read-dialog ref="onlyReadDialogRef" :visible.sync="visibleOnlyReadDialog"
                              v-if="visibleOnlyReadDialog" />
    <!--    自定义导出字段 dialog -->
    <DialogExportStuSelect :visible.sync="visibleDIYExportDialog" v-if="visibleDIYExportDialog"
                           :student-columns="studentColumns"
                           :check-list="checkList"
                           :query-info="queryInfo" />
  </table-view>
</template>

<script>
import { getStudentList, deleteStudent, addStudent } from '@/api/student'
import setStudentStatus from './dialog/setStudentStatus.vue'
import tableView from '@/vue/mixins/table-view'
import StudentDialog from '@/views/pages/recruitManage/import-student/component/studentDialog.vue'
import StudentOnlyReadDialog from '@/views/pages/recruitManage/import-student/component/studentOnlyReadDialog.vue'
import DialogExportStuSelect from '@/components/common/components/DialogExportStuSelect.vue'
import PopoverSelectFields from '@/components/common/components/PopoverSelectFields.vue'
import { cloneDeep } from 'lodash'

export default {
  components: {
    PopoverSelectFields,
    StudentOnlyReadDialog,
    StudentDialog,
    setStudentStatus,
    DialogExportStuSelect
  },
  mixins: [tableView],
  data() {
    return {
      initCheckList: ['examineNo', 'stuNo', 'stuName', 'stuStatus', 'sexType', 'collegeName', 'majorName', 'managerUserName', 'className', 'campusName', 'apartmentName', 'remarks'],
      checkList: [],
      // 当前显示的数据列
      visibleDIYExportDialog: false, // 自定义字段导出学生
      visibleOnlyReadDialog: false, // 查看学生信息
      visibleStatusDialog: false,
      queryInfo: {
        lengthOfSchooling: null,
        collegeId: '',
        majorId: '',
        stuStatus: null, // （0——未注册，1——在读，2——毕业）
        grade: new Date().getFullYear()
      }
    }
  },
  created() {
    this.checkList = cloneDeep(this.initCheckList)
  },
  mounted() {
    this.getStuStatus()
  },
  computed: {

    studentColumns() {
      if (this.$store.state.login.isAdmin) {
        return [...this.$store.state.systemParam.studentColumns, {
          prop: 'broadbandAccount',
          label: '宽带账号',
          width: '130'
        }]
      } else {
        return this.$store.state.systemParam.studentColumns
      }
    },
    compCols() {
      const result = this.$store.state.systemParam.studentColumns.filter((item) => {
        return this.checkList.includes(item.prop)
      })
      return result
    }
  },
  methods: {
    deleteStudent, // 删除api
    // 获取学生列表
    async renderTable(pageNum) {
      await this.getTableData(getStudentList, pageNum)
    },
    handleSwitch(row) {
      this.$confirm(`${row.payPassFlag ? '开启后无需缴费即可登录 智慧南职APP、智慧迎新等应用。' : ''}请确认是否${row.payPassFlag ? '允许' : '禁止'}${row.stuName}(录取编号：${row.examineNo}）的免缴费登录？`, '免缴费登录').then(async () => {
        try {
          await addStudent(row)
          this.$message.success('操作成功')
        } catch (e) {
          console.error(e)
        } finally {
          await this.renderTable()
        }
      }).catch(() => {
        row.payPassFlag = row.payPassFlag ? 0 : 1
      })
    },
    //  修改学籍信息
    showStatusDialog(row) {
      this.visibleStatusDialog = true
      this.$nextTick(() => {
        Object.keys(this.$refs.stuStatusDialogRef.formData).forEach(key => {
          this.$refs.stuStatusDialogRef.formData[key] = row[key]
        })
        this.$refs.stuStatusDialogRef.title = `-${row.stuName}(${row.stuNo ? row.stuNo : row.examineNo})`
        this.$refs.stuStatusDialogRef.setInitData()
      })
    }
  }
}
</script>
